<template>
  <div class="operation-all-logs" :style="{height:height}">
    <div class="form-container">
      <el-form :model="findForm" ref="findForm" label-width="100px" class="find-form" :inline="true">
        <el-form-item label="操作类型" prop="operationType">
          <el-select v-model="findForm.operationType" placeholder="请选择操作类型">
            <el-option v-for="item in OperationTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作对象" prop="modelName">
          <el-select v-model="findForm.modelName" placeholder="请选择操作对象">
            <el-option v-for="item in OperationModelOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作时间" prop="createTime">
          <el-date-picker class="form-input" v-model="findForm.createTime" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="操作人员" prop="userId">
          <el-select v-model="findForm.userId" placeholder="请选择操作人员" clearable filterable remote :remote-method="getUserList" :loading="loading">
            <el-option v-for="item in userList" :key="item.userId" :label="item.fullName" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item align="center">
          <el-button type="primary" @click="findOperationLogs">搜索</el-button>
          <el-button @click="resetForm('findForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="data-container">
      <div ref="history-content" class="history-content infinite-list" style="display:flex;justify-content: left; padding-top:30px;overflow:auto;margin-left:150px;" v-infinite-scroll="throttleLoad">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in historyData" :key="index" :color="activity.color" :timestamp="activity.timeDate">
            <span class="history-content-txt" @click="getOperationLogDetail(activity.requestId,$event)">{{ activity.message }}</span>
          </el-timeline-item>
        </el-timeline>
        <div class="emty">
          <el-empty :image-size="200" v-if="historyData.length === 0" description="暂无记录"></el-empty>
        </div>
      </div>
      <div class="new-old-data">
        <h5>旧数据</h5>
        <div class="old-card">
          <json-viewer :value="oldObj" :expand-depth="5" copyable boxed sort expanded></json-viewer>
        </div>
        <h5>新数据</h5>
        <div class="new-card">
          <json-viewer :value="newObj" :expand-depth="5" copyable boxed sort expanded></json-viewer>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { systemApi, userApi } from '@/api';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import { showLoading, hideLoading } from '@/plugins/loading';
import { throttle } from '@/common/utils/timerUtil.js';
export default {
  data () {
    return {
      height: '0px',
      pageSize: 20,
      pageNum: 1,
      OperationTypeOptions: [
        { value: "", label: "全部（all）" },
        { value: "add", label: "增加（add）" },
        { value: "del", label: "删除（del）" },
        { value: "upd", label: "更新（upd）" },
        { value: "oth", label: "其他（oth）" },
      ],
      OperationModelOptions: [
        { value: "", label: "全部（All）" },
        { value: "Project", label: "项目（Project）" },
        { value: "Version", label: "版本（Version）" },
        { value: "Platform", label: "平台（Platform）" },
        { value: "ProjectMembers", label: "项目成员（ProjectMembers）" },
        { value: "LinkCdn", label: "CDN资源（LinkCdn）" },
        { value: "StaticPage", label: "静态页面（StaticPage）" },
        { value: "SystemSetting", label: "系统设置（SystemSetting）" },
        { value: "FavoriteFiles", label: "收藏文件（FavoriteFiles）" },
      ],
      historyData: [],
      canLoading: true,
      oldObj: {},
      newObj: {},
      findForm: {
        operationType: '',
        modelName: '',
        userId: '',
        createTime: [new Date(+new Date() - 7 * 24 * 60 * 60 * 1000), new Date()],
      },
      userList: [],
      loading: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    // 查询操作日志
    findOperationLogs () {
      this.canLoading = true;
      this.pageNum = 1;
      // 如果没有历史记录数据
      if (!this.historyData.length) {
        // 手动调用查询接口
        this.throttleLoad();
      } else {
        // 获取节点dom对象
        const dom = this.$refs['history-content'];
        // 判断元素是否滚动
        if (dom && dom.scrollTop > 0) {
          // 由于树节点高度变化-设置空数组会默认认为滚动到底部，会自动加载查询接口
          this.historyData = [];
        } else {
          this.historyData = [];
          this.throttleLoad();
        }
      }
    },
    // 获取用户列表
    getUserList (realName) {
      this.loading = true;
      setTimeout(async () => {
        this.loading = false
        const res = await userApi.getUserList({ realName })
        this.userList = res.userInfo
      }, 200);
    },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 节流
    throttleLoad () {
      throttle(this.load, 500)
    },
    // 懒加载调用日志接口
    async load () {
      if (!this.canLoading) return;
      const parmas = { pageSize: this.pageSize, pageNum: this.pageNum, ...this.findForm }
      showLoading();
      try {
        const { code, data, message } = await systemApi.getAllOperationLogs(parmas)
        if (code === 200) {
          if (data.count / this.pageSize > this.pageNum) {
            this.pageNum++
          } else {
            this.canLoading = false
          }
          this.historyData.push(...data.rows)
          this.historyData.forEach(item => {
            if (item.userName === this.userInfo.realName) {
              item.color = "#078080";
            }
            item.timeDate = this.formatTime(item.updateTime);
            item.message = `${item.operationType}${item.modelName}(${item.userName})`;
          })
        } else {
          this.canLoading = false
          this.$message.error(message)
        }
      } catch (error) {
        this.canLoading = false
      } finally {
        hideLoading();
      }
    },
    // 获取操作日志详情
    async getOperationLogDetail (requestId, e) {
      this.setActive(e.target);
      showLoading();
      const { code, data, message } = await systemApi.getOperationLogDetail({ requestId });
      if (code === 200) {
        this.oldObj = JSON.parse(data.oldObj);
        this.newObj = JSON.parse(data.newObj);
      } else {
        this.$message.error(message);
      }
      hideLoading();
    },
    // 设置活跃类名
    setActive (dom) {
      const hTxts = document.querySelectorAll('.history-content-txt');
      hTxts.forEach(item => item.classList.remove('active'));
      dom.classList.add('active');
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted () {
    const height = document.body.offsetHeight - 250;
    this.height = height + "px";
  }
};
</script>
<style lang="less">
.operation-all-logs {
  .hisotry-form {
    display: flex;
    align-items: center;
  }
  .el-timeline-item__timestamp.is-bottom {
    position: absolute;
    left: -140px;
    top: -7px;
    color: #333;
  }
  .el-timeline {
    padding-left: 180px;
  }
  .data-container {
    display: flex;
    justify-content: space-around;
    height: 100%;
    .history-content {
      width: 40%;
      height: calc(100% - 120px);
      &-txt {
        cursor: pointer;
        &.active {
          font-weight: 700;
          color: #078080;
        }
      }
    }
    .new-old-data {
      margin-left: 20px;
      width: 50%;
      height: calc(100% - 200px);
      .old-card {
        margin-bottom: 10px;
      }
      .old-card,
      .new-card {
        max-height: 50%;
        overflow: auto;
      }
    }
    .emty {
      margin-top: 68px;
      .el-empty__description {
        display: none;
      }
    }
  }
}
</style>